import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { useHistory } from "react-router-dom";

import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateTH } from "../../../utilities/DateUtil";
import { Checkbox } from "primereact/checkbox";
import { Galleria } from "primereact/galleria";
import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonSigle, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { validateInputText } from "../../../utilities/ValidateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";

// Util
import { srcImagesFile } from "../../../utilities/FileUtil";

//css
import "./style.css";

// Page
import P202List_1 from "./P202List_1";

//SERVICE
import { pSupervisorRequest2_Info, pSupervisorRequest2_Update, pSupervisorOrderPhoto } from "../../../service/200/P202Service";

export default function P202() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errData, setErrData] = useState(null);

    const [showthumImg, setShowthumImg] = useState(false);

    const [dataArray, setDataArray] = useState([
        {
            seqPk: 0,
            displayMode: "",
            requestNo: "",
            requestType: "",
            contractNo: "",
            routeName: "",
            foreman: "",
            orderDate: "",
            orderDetail: "",
            guidelineCheckbox: null,
            guidelineNo: null,
            fixExpireCheckbox: null,
            fixExpireDate: "",
            urgentFixExpireCheckbox: null,
            urgentFixExpireDate: "",
            replyExpireDate: "",
            replyWithinDay: null,
            locationBegin: null,
            locationEnd: null,
            operateDate: "",
            operateTimeBegin: "",
            operateTimeEnd: "",
            photoSeq: 0,
            photoPath: null,
            recordStamp: 0,
        },
    ]);
    const [formObject, setFormObject] = useState({
        supervisorReason: "",
    });
    const [images, setImages] = useState([]);

    // SEARCH
    const [searchData, setSearchData] = useState({
        requestNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                });
            } else {
                history.push("/200");
                // setSearchData({
                //     requestNo: "R650300001",
                //     userId: "s16",
                // });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        on202GetData();
        getpSupervisorOrderPhoto();
    }, [searchData]);

    const getpSupervisorOrderPhoto = () => {
        pSupervisorOrderPhoto(searchData).then(
            (res) => {
                setLoading(false);
                if (res.data !== undefined) {
                    if (res.data.length > 0) {
                        let temp = [];
                        let index = 1;
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            setShowthumImg(element.photoPath === null ? false : true);
                            index++;
                        });
                        setImages(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const on202GetData = () => {
        setLoading(true);
        pSupervisorRequest2_Info(searchData).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res.data !== undefined) {
                    if (res.data.length > 0) {
                        let temp = [];
                        let index = 1;
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });

                            setShowthumImg(element.photoPath === null ? false : true);

                            index++;
                        });
                        setDataArray(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const validation = (object, act) => {
        if (act !== "A") {
            if (object.supervisorReason === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = (act) => {
        if (validation(formObject, act)) {
            setLoading(true);
            const req = {
                actionCode: act,
                requestNo: searchData.requestNo,
                supervisorReason: formObject.supervisorReason,
                userId: searchData.userId,
                recordStamp: setViewForm("recordStamp"),
            };
            // console.log(req);
            pSupervisorRequest2_Update(req).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        const _alert = res.data[0];
                        setdialogOption({
                            ...dialogOption,
                            header: _alert.statusCode === "C" ? "บันทึกสมบูรณ์" : "มีข้อผิดพลาด",
                            content: _alert.statusText,
                            footerBtn: () => footerButtonSingle(),
                        });
                        setConfirmDialog({ open: true });
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const footerButtonSingle = () => {
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => handlerBack()} />;
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const galleriaResponsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 5,
        },
        {
            breakpoint: "960px",
            numVisible: 4,
        },
        {
            breakpoint: "768px",
            numVisible: 3,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
        },
    ];

    // const galleriaItemTemplate = (item) => <img src={`assets/${item.itemImageSrc}`} alt={item.alt} style={{ width: "100%", display: "block" }} />;
    // const galleriaThumbnailTemplate = (item) => <img src={`assets/${item.thumbnailImageSrc}`} alt={item.alt} style={{ width: "100%", display: "block" }} />;

    const galleriaItemTemplate = (item) => {
        return <img {...srcImagesFile(item.photoPath)} alt={item.alt} style={{ width: "100%", display: "block" }} />;
    };

    const galleriaThumbnailTemplate = (item) => {
        return <img {...srcImagesFile(item.photoPath)} alt={item.alt} style={{ width: "30%", display: "block" }} />;
    };

    const handlerChk = (_val) => {
        return _val === "Y" ? true : false;
    };

    const handlerBack = () => {
        history.push("/200");
    };

    const handlerDisplayMode = () => {
        return setViewForm("displayMode") !== "D" ? true : false;
    };

    const setViewForm = (key) => {
        return dataArray[0][key];
    };

    const footerButtonCon = (act) => {
        return (
            <FooterButtonCustomLabel
                labelCon="ยืนยัน"
                lableCan="ยกเลิก"
                onClickOk={() => {
                    submitForm(act);
                    setConfirmDialog({ open: false });
                }}
                onClickCancle={() => setConfirmDialog(false)}
            />
        );
    };

    const handlerSettingDialogConfirm = (key, _content) => {
        if (key === "R") {
            if (!validation(formObject)) {
                return true;
            }
        }
        setdialogOption({
            ...dialogOption,
            header: "",
            content: _content,
            footerBtn: () => footerButtonCon(key),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={setViewForm("requestNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" placeholder="ระบุ ประเภทงาน" disabled={true} maxLength="100" value={setViewForm("requestType")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" disabled={true} maxLength="20" value={setViewForm("contractNo")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" disabled={true} maxLength="5" value={setViewForm("routeName")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="orderDate">วันที่สั่ง</label>
                                {/* <Calendars value={new Date(dataArray.announce_finish_date)} minDate={new Date(dataArray.announce_start_date)} onChange={(e) => setDataArray({ ...dataArray, announce_finish_date: e.target.value })} disabled={true} /> */}
                                <InputText id="orderDate" type="text" disabled={true} maxLength="5" value={setViewForm("orderDate")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="orderDate">เลขที่ใบแจ้งฯต้นเรื่อง</label>
                                {/* <Calendars value={new Date(dataArray.announce_finish_date)} minDate={new Date(dataArray.announce_start_date)} onChange={(e) => setDataArray({ ...dataArray, announce_finish_date: e.target.value })} disabled={true} /> */}
                                <InputText id="originalRequestNo" type="text" disabled={true} maxLength="20" value={setViewForm("originalRequestNo")} />
                            </div>
                        </div>
                        <hr />

                        <div className="p-field p-col-12 p-md-12">
                            <label htmlFor="orderDetail">งานสั่งการเฉพาะอย่าง</label>
                            <P202List_1 dataTable={dataArray} />
                        </div>
                        <div className="p-grid nested-grid">
                            <div className="p-col-8">
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="guidelineCheckbox" name="option" checked={handlerChk(setViewForm("guidelineCheckbox"))} disabled={true} />
                                                <label htmlFor="guidelineNo">เพื่อเป็นเเนวทางปฏิบัติ</label>
                                                <InputText style={{ marginLeft: "5px" }} id="guidelineNo" type="text" disabled={true} value={setViewForm("guidelineNo")} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="fixExpireCheckbox" name="option" checked={handlerChk(setViewForm("fixExpireCheckbox"))} disabled={true} />
                                                <label htmlFor="fixExpireDate">เพื่อปรับปรุงแก้ไขภายในวันที่</label>
                                                <InputText style={{ marginLeft: "5px" }} id="fixExpireDate" type="text" disabled={true} value={setViewForm("fixExpireDate")} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="urgentFixExpireCheckbox" name="option" checked={handlerChk(setViewForm("urgentFixExpireCheckbox"))} disabled={true} />
                                                <label htmlFor="urgentFixExpireDate">เพื่อเร่งรัดดำเนินการโดยด่วน ภายในวันที่</label>
                                                <InputText style={{ marginLeft: "5px" }} id="urgentFixExpireDate" type="text" disabled={true} value={setViewForm("urgentFixExpireDate")} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="replyExpireCheckbox" name="option" value="Chicago4" checked={handlerChk(setViewForm("replyExpireCheckbox"))} disabled={true} />
                                                <label htmlFor="replyExpireDate">โปรดตอบเป็นหนังสือภายในวันที่</label>
                                                <InputText style={{ marginLeft: "5px" }} id="replyExpireDate" type="text" disabled={true} value={setViewForm("replyExpireDate")} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-10">
                                                    <label htmlFor="replyWithinDay">แก้ไขและตอบกลับภายใน(วัน)</label>
                                                    {/* <Calendars value={new Date(dataArray.reply_within_day)} minDate={new Date(dataArray.reply_within_day)} onChange={(e) => setDataArray({ ...dataArray, reply_within_day: e.target.value })} disabled={true} /> */}
                                                    <InputText style={{ marginLeft: "5px" }} id="replyWithinDay" type="text" disabled={true} value={setViewForm("replyWithinDay")} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                                    {/* <InputNumber id="locationBegin" mode="decimal" useGrouping={false} max={99999999999} minFractionDigits={3} maxFractionDigits={3} value={setViewForm("locationBegin")} disabled={true} /> */}
                                                    <InputText id="locationBegin" type="text" disabled={true} maxLength="10" value={setViewForm("locationBegin")} />
                                                </div>
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="locationEnd">ถึง</label>
                                                    {/* <InputNumber id="locationEnd" mode="decimal" useGrouping={false} max={99999999999} minFractionDigits={3} maxFractionDigits={3} value={setViewForm("locationEnd")} disabled={true} /> */}
                                                    <InputText id="locationEnd" type="text" disabled={true} maxLength="10" value={setViewForm("locationEnd")} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="p-col-12">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-10">
                                                    <label htmlFor="operateDate">วันที่ออกปฏิบัติงาน</label>
                                                    <InputText id="operateDate" type="text" disabled={true} value={setViewForm("operateDate") === "" ? "" : formatDateTH(setViewForm("operateDate"), false)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="operateTimeBegin">วันที่เวลาขอออกปฏิบัติงานจาก</label>
                                                    <InputText id="operateTimeBegin" type="text" disabled={true} value={setViewForm("operateTimeBegin")} />
                                                </div>
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="operateTimeEnd">วันที่เวลาขอออกปฏิบัติงานถึง</label>
                                                    <InputText id="operateTimeEnd" type="text" disabled={true} value={setViewForm("operateTimeEnd")} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-12">
                                                    <label htmlFor="foreman">หัวหน้างาน</label>
                                                    {/* <Dropdown id="foreman" value={dropdownItem} onChange={(e) => setDropdownItem(e.value)} options={dropdownItems} optionLabel="name" placeholder="เลือก หัวหน้างาน" disabled={true}></Dropdown> */}
                                                    <InputText id="foreman" type="text" disabled={true} value={setViewForm("foreman")} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="reportDtBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                                    <InputText id="reportDtBegin" type="text" disabled={true} value={setViewForm("reportDtBegin")} />
                                                </div>
                                                <div className="p-field p-col-12 p-md-6">
                                                    <label htmlFor="reportDtEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                                    <InputText id="reportDtEnd" type="text" disabled={true} value={setViewForm("reportDtEnd")} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-10">
                                        <div className="box">
                                            <div className="p-fluid p-formgrid p-grid">
                                                <div className="p-field p-col-12 p-md-12">
                                                    <label htmlFor="supervisorReason">เหตุผล</label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <InputTextarea
                                                        id="supervisorReason"
                                                        className={submitted && !dataArray.supervisorReason ? "p-invalid" : ""}
                                                        rows="4"
                                                        style={{ width: "100%" }}
                                                        value={formObject.supervisorReason}
                                                        placeholder="ระบุ เหตุผล"
                                                        onChange={(e) => setFormObject({ ...dataArray, supervisorReason: e.target.value })}
                                                        disabled={handlerDisplayMode()}
                                                    />
                                                    {submitted && !dataArray.supervisorReason && validateInputText("supervisorReason", "เหตุผล")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-4">
                                <div className="box box-stretched">
                                    <div className="p-col-12">
                                        <div className="p-grid p-fluid media-demo" style={{ marginTop: "20%" }}>
                                            <div className="p-col-12">
                                                <Galleria showThumbnails={showthumImg} value={images} responsiveOptions={galleriaResponsiveOptions} numVisible={7} circular style={{ maxWidth: "300px", margin: "auto" }} item={galleriaItemTemplate} thumbnail={galleriaThumbnailTemplate}></Galleria>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button" icon="pi pi-check" label="อนุมัติ" style={{ width: 170 }} onClick={() => handlerSettingDialogConfirm("A", "ต้องการอนุมัติใบแจ้งฯ หรือไม่")} disabled={handlerDisplayMode()} />
                                <Button className="p-button-warning p-button" icon="pi pi-ban" label="ไม่อนุมัติ" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerSettingDialogConfirm("R", "ต้องการไม่อนุมัติใบแจ้งฯ หรือไม่")} disabled={handlerDisplayMode()} />
                                <Button
                                    className="p-button-secondary p-button"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => handlerBack()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            </div>
        </>
    );
}
